export default __webpack_public_path__ + "static/media/ProductCollections.4a43524f.png";